var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.value ? _c('view-card', {
    attrs: {
      "title": _vm.title
    }
  }, [_vm.isAuthorized ? _c('v-row', {
    attrs: {
      "slot": "title-actions"
    },
    slot: "title-actions"
  }, [_c('v-spacer'), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('view-description-modify', {
    on: {
      "input": _vm.sync
    },
    model: {
      value: _vm.expert,
      callback: function callback($$v) {
        _vm.expert = $$v;
      },
      expression: "expert"
    }
  })], 1)], 1) : _vm._e(), _c('data-list', {
    attrs: {
      "dataList": _vm.dataList
    }
  })], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }